import { create } from "zustand";

interface AddDemoAccountState {
  open: boolean;
  batchId: string | null;
  openDialog: () => void;
  closeDialog: () => void;
  setBatchId: (id: string | null) => void;
}

export const useAddDemoAccountStore = create<AddDemoAccountState>()((set) => ({
  open: false,
  batchId: null,
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false, batchId: null }),
  setBatchId: (id: string | null) => set({ batchId: id }),
}));
